import { Component, ViewChild, ElementRef  } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, Platform, MenuController } from 'ionic-angular';
import { RequestServiceProvider } from '../../providers/request-service/request-service';
import { File } from '@ionic-native/file';
declare var cordova:any;

/**
 * Generated class for the RegisterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment:'register'
})
@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {

  @ViewChild('regSlider') regSlider: any;

  slideOneForm: FormGroup;
  slideTwoForm: FormGroup;
  slideThreeForm: FormGroup;
  submitAttempt: boolean = false;
  loader;
  addressImage:any;
  addressPath:any;
  photoImage:any;
  photoPath:any;
  states: Array<Object>;
  cities: Array<Object>;
  guessedBanks = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private menu: MenuController,public formBuilder: FormBuilder, private auth: RequestServiceProvider, private alertCtrl: AlertController, private loading: LoadingController, private platform: Platform) {

        this.menu.enable(false);
        this.menu.swipeEnable(false);

        this.slideOneForm = this.formBuilder.group({
          fullName: ['',Validators.required],
          phoneNumber:['',Validators.compose([Validators.minLength(11),Validators.maxLength(11),Validators.required])],
          businessName:['',Validators.required],
          employmentType:['',Validators.required],
          bankName:['',Validators.required],
          bankAccount:['',Validators.compose([Validators.minLength(10),Validators.maxLength(10),Validators.required])],
          bvn:['',Validators.required]

      });

      this.slideTwoForm = this.formBuilder.group({
        identification: ['',Validators.required],
        state:['',Validators.required],
        city:['',Validators.required],
        address:['',Validators.required],
        agent_type:['',Validators.required],
        addressVerify:[{value: '', disabled: true},Validators.required],
        agentPhoto:[{value: '', disabled: true},Validators.required]
    });

    this.auth.getStatesAndCities().subscribe(
      data => {

        console.log(data);
        this.states = data;
      }
    )
  }




  next(){
    this.regSlider.slideNext();
  }

  prev(){
      this.regSlider.slidePrev();
  }

  presentLoading(content){
    this.loader = this.loading.create({
      content:content
    })
    this.loader.present();
  }

  getLga(state){
    console.log('hello');
    console.log(state);
    this.cities = state.lga;
  }

  addressScan(){
    let file = new File();
    this.platform.ready().then(() => {
      if (typeof cordova !== 'undefined') {
        cordova.plugins.GeniusScan.setLicenceKey(
          "533c500550570105095d005839525a0e4a1353165f4153404c44510753415351115c090d5a5c5a523a03040653530604535158",
          (fileUri) => {

          },
          (errorMessage) => {

          },
        );
        cordova.plugins.GeniusScan.scanCamera(

          (fileUri) => {

            let filename = fileUri.substring(fileUri.lastIndexOf('/')+1);
            let path =  fileUri.substring(0,fileUri.lastIndexOf('/')+1);
            this.addressPath = `${path}${filename}`;
            this.presentLoading('uploading...')
            file.readAsDataURL(path, filename).then(
              res => {
                this.addressImage = res;
                this.loader.dismiss().catch(()=>{});
              }

            );

          },
          function onError(){
            console.log('Its not scanning');
          }
        );
      }
    });
  }

  photoScan(){
    let file = new File();
    this.platform.ready().then(() => {
      if (typeof cordova !== 'undefined') {
        cordova.plugins.GeniusScan.setLicenceKey(
          "533c500550570105095d005839525a0e4a1353165f4153404c44510753415351115c090d5a5c5a523a03040653530604535158",
          (fileUri) => {

          },
          (errorMessage) => {

          },
        );
        cordova.plugins.GeniusScan.scanCamera(

          (fileUri) => {

            let filename = fileUri.substring(fileUri.lastIndexOf('/')+1);
            let path =  fileUri.substring(0,fileUri.lastIndexOf('/')+1);
            this.photoPath = `${path}${filename}`;
            this.presentLoading('uploading...');
            file.readAsDataURL(path, filename).then(
              res=>{
                this.photoImage = res ;
                this.loader.dismiss().catch(()=>{});
              }
            );

          },
          function onError(){
            console.log('Its not scanning');
          }
        );
      }
    });
  }


  checkAccount(event){
    console.log(event.value.length)
    if(event.value.length == 10){
      this.auth.guessBankAccount(event.value).subscribe(
        data => {
          console.log(data)
          this.guessedBanks = data;
        },
        error => {
          console.log(error)
        }
      )
    }

}


  save(){
    this.submitAttempt = true;

    if(!this.slideOneForm.valid){
        this.regSlider.slideTo(0);
    }else if(!this.slideTwoForm.valid){
        this.regSlider.slideTo(1);
    }

    else {

      let data = Object.assign({},this.slideOneForm.value,this.slideTwoForm.value,{addressVerify:this.addressImage,agentPhoto:this.photoImage})
       // console.log(data);
       // console.log(this.slideOneForm.value);
       // console.log(this.slideTwoForm.value);

        this.presentLoading('submitting...');
        this.auth.postAgentRegistration(data).subscribe(
          data => {
            console.log(data);
            this.loader.dismiss().catch(()=>{});
             if(data.status == 200){

              let alert = this.alertCtrl.create({
                title:"Registration",
                subTitle:"Registration Successful",
                buttons:['OK']
              })
              alert.present();
              this.slideOneForm.reset();

             this.slideTwoForm.reset();

           //  this.navCtrl.push(AgentPage);
            }

          }

        )

    }
  }





  ionViewDidLoad() {
    console.log('ionViewDidLoad RegisterPage');
  }

  ionViewWillEnter(){
    this.menu.enable(false);
    this.menu.swipeEnable(false);
  }



}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts